// Turns the visitor's consent choice into what loads. Nothing here runs at
// page load on its own: main.js calls applyStoredConsent() on boot, and the
// cookie banner calls syncConsent() after a live choice. This is what keeps
// tags from firing before opt in (UK PECR / UK GDPR).
//
// Analytics is Improve Newco's own GA4 (analytics.js). Marketing has no
// loader of its own: the consent aware embeds (DemoVideo, EmbedFrame) read
// hasMarketing() and refresh on "consent-updated". Crm is Popcorn
// (popcorn.js), reported after each navigation by router.js.
//
// Plan: docs/plans/analytics-newco-replacement-2026-10.md in the tracker repo.

import { hasAnalytics, hasCrm, forgetLegacyConsent } from '@/utils/consent';
import { eventBus } from '@/utils/eventBus';
import { trackPopcorn, isPopcornLoaded, clearPopcorn } from '@/utils/popcorn';
import {
  loadAnalytics,
  clearAnalytics,
  isAnalyticsLoaded,
  trackPageView,
  watchInteractions,
  applyStaffMode,
} from '@/utils/analytics';

// On every page load: drop the version 1 cookie, then re-apply the stored
// choice so a returning visitor who accepted still gets analytics.
export function applyStoredConsent() {
  forgetLegacyConsent();
  if (typeof window !== 'undefined') applyStaffMode(window.location.search);
  // CTA clicks and form starts: sent only once analytics is allowed.
  watchInteractions();
  if (hasAnalytics()) loadAnalytics();
}

// After a LIVE choice (the banner, or the footer "Cookie settings" link).
// setConsent() must be called first.
export function syncConsent() {
  // Refused or withdrawn while a tag ran on this page: reload, because a
  // single page app never unloads a tag on its own; the stored choice keeps
  // it off after the reload.
  let reload = false;
  if (hasAnalytics()) {
    // Granted just now: the page the visitor is on counts as the first view.
    if (!isAnalyticsLoaded()) trackPageView();
  } else {
    // Stop Google and delete its cookies.
    reload = isAnalyticsLoaded();
    clearAnalytics();
  }
  if (hasCrm()) {
    // Granted just now: Popcorn hears about the page the visitor is on.
    if (!isPopcornLoaded()) trackPopcorn();
  } else {
    // Forget the remembered Popcorn contact.
    reload = reload || isPopcornLoaded();
    clearPopcorn();
  }
  if (reload && typeof window !== 'undefined') {
    window.location.reload();
    return;
  }
  eventBus.$emit('consent-updated');
}
